import { Blac } from "blac-next";
import React, { useState } from "react";
import {
  isBootScreenPinned,
  pinBootScreen,
  unpinBootScreen
} from "src/lib/bootScreen";
import AppDebugCubit from "./AppDebugCubit";
import { DebugButton, DebugButtonRow } from "./debug.styles";

const DebugBootScreen = () => {
  const [pinned, setPinned] = useState(isBootScreenPinned);

  const show = () => {
    pinBootScreen();
    setPinned(true);
    Blac.getBloc(AppDebugCubit).setMinified(true);
  };

  const dismiss = () => {
    unpinBootScreen();
    setPinned(false);
  };

  return (
    <DebugButtonRow>
      <DebugButton onClick={show} disabled={pinned}>
        Show Boot Screen
      </DebugButton>
      <DebugButton onClick={dismiss} disabled={!pinned}>
        Dismiss
      </DebugButton>
    </DebugButtonRow>
  );
};

export default DebugBootScreen;
